export default __webpack_public_path__ + "static/media/RFNet Nodes.fa2fa389.jpg";